// extracted by mini-css-extract-plugin
module.exports = {"collectionGoals":"CollectionGoals_collectionGoals__2tAgZ","goal":"CollectionGoals_goal__11q3m","fulfilled":"CollectionGoals_fulfilled__2Cr_b"};